import { Directive } from '@angular/core';

@Directive({
  selector: '[inmCarouselPoint]',
  standalone: true,
  host: {
    class: 'inm-carousel__points',
  },
})
export class InmCarouselPoint {}
